import * as React from "react";

import {ApiClient} from "../../../services/ApiClient";
import {IControlError, IControlSchema} from "../../Controls";
import {Component, I18NString} from "../../Utils";
import {IDispatcher} from "../extensions/Dispatcher";
import Field from '../Field';
import {isNull, isArray, isEmpty} from'lodash';
import Alert from './Alert';
import Select from 'react-select';
import {isNullOrUndefined} from "util";

export interface IDropBoxOptionSchema {
    key: number,
    value: I18NString
}

export interface IDropBoxSchema extends IControlSchema {
    description: I18NString;
    options: Array<IDropBoxOptionSchema>;
    value?: any;
    disabled?: boolean;
    multi?:boolean;
    optionsUrl: string;
}

export interface IDropBoxProps {
    schema: IDropBoxSchema;
    api: ApiClient;
    dispatcher?: IDispatcher;
    error: IControlError | undefined;
    visited: boolean;
}

interface OptionsType {
    value: number;
    label: string;
}

interface State {
    openInfo: boolean;
    isLoading: boolean;
    options: Array<OptionsType>;
}

const mapOptions = (array) => {
    if (!Array.isArray(array)) {
        return [];
    }

    return array.map((o) => ({ value: o.id, label: o.value.ru }))
}

class DropBox extends Component<IDropBoxProps, State> {
    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state = {
            openInfo: false,
            isLoading: false,
            options: [],
        }
    }

    protected onChange(select) {
        const { dispatcher } = this.props;
        
        if (isArray(select)) {
            dispatcher.onAddValueRefresh(this.props.schema.id, isEmpty(select) ? null : select, undefined);
        } else {
            let value;
            if (this.state.options && this.state.options.length) {
                value = select;
            } else {
                value = isNull(select) ? null : select.value === 0 ? null : String(select.value);
            }
            dispatcher.onAddValueRefresh(this.props.schema.id, isNull(value) ? null : typeof value === "object" ? value : value.toString(), undefined);
        }
    }

    componentDidMount() {
        const {
			api,
			schema: { optionsUrl },
		} = this.props;

		if (optionsUrl) {
            this.setState({ isLoading: true });
            api.getOptions(optionsUrl, {
                success: (data) => {
                    const options = mapOptions(data);

                    this.setState({
                        options,
                        isLoading: false,
                    });
                },
                error: () => {
                    this.setState({ isLoading: false });
                },
            });
        }
    }

    onClick(){
        this.setState({ openInfo: !this.state.openInfo })
    }

    public render() {
        const { isLoading } = this.state;
        const { schema: {disabled, description, multi, value}, visited, error } = this.props;
        const arr = this.props.schema.options.map((o: IDropBoxOptionSchema) => ({ value: o.key, label: o.value.ru }) );
        const errorMessage = visited && error && error.message;

        let statusField = 'default';
        if (!isNullOrUndefined(value) && !this.props.schema.disabled) {
            statusField = "success";
        } 
       
        return (
            <Field {...this.props.schema} status={isNullOrUndefined(value) ? "default" : "success"} >
                <div className="input-group">
                    {!isLoading ? (
                        <Select
                            autosize={false}
                            multi={multi}
                            name="form-field-name"
                            className="has-success"
                            placeholder="Выберите из списка"
                            value={value}
                            disabled={disabled}
                            style={{
                                width: "100%",
                                borderColor:
                                    statusField === "default"
                                        ? "#ccc"
                                        : "#4eb43e",
                             }}
                            onChange={this.onChange}
                            options={
                                this.state.options && this.state.options.length
                                    ? this.state.options
                                    : arr
                            }
                        />
                    ) : (
                        <p>Загрузка...</p>
                    )}

                      {
                          (description) && (
                            <span onClick={this.onClick} className="input-group-addon btn btn-default">
                                <span className="fa fa-question-circle-o fa-fw"></span>
                            </span>
                          )
                      }
                 </div> 
                {description && this.state.openInfo &&
                    (<div  className="alert alert-warning" role="alert">{this.tr(this.props.schema.description)}</div>) 
                }
                {errorMessage && (<Alert>{errorMessage}</Alert>)}
            </Field>
        );
    }
}

export function createDropBox(schema: IControlSchema, api: ApiClient, dispatcher: IDispatcher = null, error: IControlError | undefined, visited: boolean): React.ReactElement<any> {
    return <DropBox schema={schema as IDropBoxSchema} api={api} dispatcher={dispatcher} error={error} visited={visited}/>;
}


// WEBPACK FOOTER //
// ./src/components/controls/standart/DropBox.tsx